/**
 * Tenantless Cosmos registration (KIM-12). The current wire contract returns
 * absolute DateTimeOffset strings; invite registration still uses seconds.
 * useRegistrationFlow validates the response before committing token state.
 * Source: CosmosRegistrationWireModels at BE 7b23291, FW-314.
 */
import { useIdentityApiClient, useMutation, type UseMutationReturnType } from '@fusapp-work/shell'

export interface RegistrationStartInput {
  readonly firstName: string
  readonly lastName: string
  readonly email: string
}

export interface RegistrationStartResponse {
  readonly registrationToken: string
  readonly otpExpiresAt: string
  readonly tokenExpiresAt: string
}

export function useRegistrationStart(): UseMutationReturnType<RegistrationStartResponse, Error, RegistrationStartInput, unknown> {
  const apiClient = useIdentityApiClient()
  return useMutation({
    mutationFn: (body: RegistrationStartInput) =>
      apiClient.request<RegistrationStartResponse>('/api/v1/registration/start', { method: 'POST', body }),
  })
}
